import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/globals.css";
import i18n from "./lib/i18n";

// Wait for i18n to be fully initialized before rendering React
i18n.init().then(() => {
  ReactDOM.createRoot(
    document.getElementById("root")!
  ).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
